/**
 * Состав пака «clean-white» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 29 воронок: группы.json, группы 7 (PACK в matrix.py)
  palettes: [
    // 8 из 29 воронок: palette → ближайшая тема по цветам
    { themeId: 'paper-white', weight: 0.28 },
    // 5 из 29 воронок: palette → ближайшая тема по цветам
    { themeId: 'rose-blush', weight: 0.17 },
    // 3 из 29 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.1 },
  ],
  fonts: [
    // 25 из 29 воронок: fontId
    { fontId: 'inter', weight: 0.86 },
    // 2 из 29 воронок: fontId
    { fontId: 'poppins', weight: 0.07 },
  ],
  screenKinds: [
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.392; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.44 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.145
    { kind: 'I1', share: 0.16 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.097; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.11 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.071
    { kind: 'N5', share: 0.08 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.057
    { kind: 'N1', share: 0.06 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.048; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.05 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.043
    { kind: 'N2', share: 0.05 },
    // средняя доля экранов по 29 воронкам (признаки.json kinds) 0.037
    { kind: 'N4', share: 0.04 },
  ],
  blocks: [
    // в 26 из 29 воронок (признаки.json blocks), подъём 1.99; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 86 из 165, optionIconPosition 90 из 165
    {
      type: 'multiple_choice',
      weight: 0.9,
      settings: { optionIndicator: 'none', optionIconPosition: 'left' },
    },
    // в 28 из 29 воронок (признаки.json blocks), подъём 1.41; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 382 из 396, optionIndicator 218 из 396
    {
      type: 'single_choice',
      weight: 0.97,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 13 из 29 воронок (признаки.json blocks), подъём 9.69
    { type: 'bmi_scale', weight: 0.45, settings: {} },
    // в 24 из 29 воронок (признаки.json blocks), подъём 2.86
    { type: 'text_field', weight: 0.83, settings: {} },
    // в 17 из 29 воронок (признаки.json blocks), подъём 3.83; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): unitPickerLook 31 из 41, unitToggleLook 31 из 41, unitTogglePosition 31 из 41
    {
      type: 'weight_picker',
      weight: 0.59,
      settings: {
        unitPickerLook: 'big-number',
        unitToggleLook: 'pill',
        unitTogglePosition: 'above',
      },
    },
    // в 16 из 29 воронок (признаки.json blocks), подъём 3.61; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): unitPickerLook 15 из 17, unitToggleLook 15 из 17, unitTogglePosition 15 из 17
    {
      type: 'height_picker',
      weight: 0.55,
      settings: {
        unitPickerLook: 'big-number',
        unitToggleLook: 'pill',
        unitTogglePosition: 'above',
      },
    },
    // в 23 из 29 воронок (признаки.json blocks), подъём 1.97
    { type: 'email', weight: 0.79, settings: {} },
  ],
  niches: [
    // 12 из 29 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.41 },
    // 3 из 29 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.1 },
    // 3 из 29 воронок (признаки.json theme)
    { niche: 'parenting', weight: 0.1 },
    // 3 из 29 воронок (признаки.json theme)
    { niche: 'self_improvement', weight: 0.1 },
  ],
};
